import { render, staticRenderFns } from "./AwardTender.vue?vue&type=template&id=7a96516a&scoped=true&"
import script from "./AwardTender.vue?vue&type=script&lang=js&"
export * from "./AwardTender.vue?vue&type=script&lang=js&"
import style0 from "./AwardTender.vue?vue&type=style&index=0&id=7a96516a&lang=scss&scoped=true&"
import style1 from "./AwardTender.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a96516a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a96516a')) {
      api.createRecord('7a96516a', component.options)
    } else {
      api.reload('7a96516a', component.options)
    }
    module.hot.accept("./AwardTender.vue?vue&type=template&id=7a96516a&scoped=true&", function () {
      api.rerender('7a96516a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/review/AwardTender.vue"
export default component.exports